import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["hit"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SearchResult from '../search-result';
import style from '../index.module.scss';
import WestfieldProductCard from '../../westfield-product-card';
import getUrlForHit from '../get-url-for-hit';
import { getFieldForSegment } from '../display-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const getCommonProps = _ref => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref;
  const key = hit.objectID;
  const onClick = () => onResultClick(hit);
  const href = getUrlForHit(hit, context);
  const highlightField = getFieldForSegment(hit.segment);
  return {
    hit,
    key,
    index,
    onClick,
    href,
    highlightField
  };
};
const renderNationalStorefront = _ref2 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref2;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "nationalStorefront",
    description: 'All stores',
    className: style.storeRow,
    imageBgSize: "contain",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult"
  }));
};
const renderStore = _ref3 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref3;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "store",
    description: context.centre.title,
    className: style.storeRow,
    imageBgSize: "contain",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_1"
  })) : null;
};
const renderSite = _ref4 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref4;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "site",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_2"
  })) : null;
};
const renderService = _ref5 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref5;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "service",
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_3"
  })) : null;
};
const renderLocalOffer = _ref6 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref6;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "offer",
    description: hit.storeTitles.join(', '),
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_4"
  })) : null;
};
const renderNationalOffer = _ref7 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref7;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "national-offer",
    description: hit.storeTitles.join(', '),
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_5"
  }));
};
const renderEvent = _ref8 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref8;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "event",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_6"
  })) : null;
};
const renderLocalNews = _ref9 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref9;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "local-news",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_7"
  })) : null;
};
const renderNationalNews = _ref10 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref10;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "national-news",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_8"
  }));
};
const renderLocalStory = _ref11 => {
  let {
    hit,
    onResultClick,
    context,
    index
  } = _ref11;
  return context.centre ? /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "local-story",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_9"
  })) : null;
};
const renderNationalStory = _ref12 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref12;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    imageUrl: hit.img,
    hitKind: "national-story",
    description: hit.shortDescription,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_10"
  }));
};
const renderCentre = _ref13 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref13;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "centre",
    isTextBold: false,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_11"
  }));
};
const renderOnlineService = _ref14 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref14;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "online-service",
    isTextBold: false,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_12"
  }));
};
const renderNearCentreStore = _ref15 => {
  let {
    hit,
    onResultClick,
    index,
    context
  } = _ref15;
  return /*#__PURE__*/_jsx(SearchResult, _objectSpread(_objectSpread({}, getCommonProps({
    hit,
    onResultClick,
    index,
    context
  })), {}, {
    noImage: true,
    hitKind: "other-store",
    description: hit.centreName,
    className: style.otherStoreRow,
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_SearchResult_13"
  }));
};
const renderWestfieldProduct = _ref16 => {
  let {
    hit,
    onResultClick
  } = _ref16;
  return /*#__PURE__*/_jsx(WestfieldProductCard, {
    westfieldProduct: hit,
    onClick: () => onResultClick(hit),
    "data-id": "group-and-render-segments_get-render-for-segment_renderNationalStorefront_WestfieldProductCard"
  }, hit.objectID);
};
const getRenderForSegment = _ref17 => {
  let {
      hit
    } = _ref17,
    rest = _objectWithoutProperties(_ref17, _excluded);
  switch (hit.segment) {
    case 'nationalStorefronts':
      return renderNationalStorefront(_objectSpread({
        hit
      }, rest));
    case 'stores':
      return renderStore(_objectSpread({
        hit
      }, rest));
    case 'sites':
      return renderSite(_objectSpread({
        hit
      }, rest));
    case 'services':
      return renderService(_objectSpread({
        hit
      }, rest));
    case 'localOffers':
      return renderLocalOffer(_objectSpread({
        hit
      }, rest));
    case 'nationalOffers':
      return renderNationalOffer(_objectSpread({
        hit
      }, rest));
    case 'events':
      return renderEvent(_objectSpread({
        hit
      }, rest));
    case 'localNews':
      return renderLocalNews(_objectSpread({
        hit
      }, rest));
    case 'nationalNews':
      return renderNationalNews(_objectSpread({
        hit
      }, rest));
    case 'localStories':
      return renderLocalStory(_objectSpread({
        hit
      }, rest));
    case 'nationalStories':
      return renderNationalStory(_objectSpread({
        hit
      }, rest));
    case 'centres':
      return renderCentre(_objectSpread({
        hit
      }, rest));
    case 'onlineServices':
      return renderOnlineService(_objectSpread({
        hit
      }, rest));
    case 'otherStores':
      return renderNearCentreStore(_objectSpread({
        hit
      }, rest));
    case 'westfieldProducts':
      return renderWestfieldProduct(_objectSpread({
        hit
      }, rest));
    default:
      throw new Error("Unknown segment ".concat(hit.segment));
  }
};

// TODO rename this file and export
export default getRenderForSegment;